<template>
  <div class="chart">
    <commitChart v-if="chartData" :chartData="chartData" :options="options" />
  </div>
</template>

<script>
  import commitChart from '@/chart/commitChart.js'

  export default {
    name: 'Chart',
    props: {
      title: {
        type: String
      },
      label: {
        type: String
      },
      labels: {
        type: Array
      },
      dataPoints: {
        type: Array
      },
      alarmLevel: {
        type: Number
      },
      xLabel: {
        type: String
      },
      yLabel: {
        type: String
      },
      min: {
        type: Number
      },
      max: {
        type: Number
      }
    },
    components: {
      commitChart
    },
    computed: {
      chartData: function () {
        return {
          labels: this.labels,
          datasets: [
            {
              label: this.label,
              fill: false,
              data: this.preparedData,
              showLine: true,
              radius: 0,
              borderColor: '#00AA00',
              backgroundColor: '#00AA00',
              borderWidth: 1
            },
            {
              label: this.$t('hs.att-dashboard.alarm-level'),
              fill: false,
              showLine: true,
              borderColor: '#0000ff',
              backgroundColor: '#0000ff',
              data: this.preparedSecondaryData,
              borderWidth: 1,
              radius: 0,
              min: 1
            } /*,
            {
              label: this.$t('hs.att-dashboard.markers'),
              fill: false,
              borderColor: '#ff0000',
              backgroundColor: '#ff0000',
              data: [{x: 1, y: -168}]
            } */
          ]
        }
      },
      preparedData () {
        return this.dataPoints.map((o, i) => {
          return { x: this.labels[i], y: o }
        })
      },
      preparedSecondaryData () {
        return this.dataPoints.map((o, i) => {
          return { x: this.labels[i], y: this.alarmLevel }
        })
      },
      options () {
        return {
          title: {
            display: true,
            text: this.title
          },
          responsive: true,
          elements: {
            line: {
              tension: 0
            }
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.xLabel
              },
              ticks: {
                min: Math.min(...this.labels),
                max: Math.max(...this.labels),
                stepSize: (Math.max(...this.labels) - Math.min(...this.labels)) / 10
              }
            }],
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.yLabel
              },
              ticks: {
                suggestedMin: Math.min(...this.dataPoints) - 40,
                suggestedMax: Math.max(...this.dataPoints) + 40
              }
            }]
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
